APP.Documents = (/** @lends APP.Dashboard */function () {
	'use strict';

	var exports,
		$body,
		inited = false,
		dashboardTypeDoc;


	function init() {

		$body = APP.Performance.getCachedDOM().$body;
		dashboardTypeDoc = $body.find('[data-dashboard-documents]') || false;

		if(dashboardTypeDoc) {
			if (inited === false) {
				inited = true;
				console.log(dashboardTypeDoc);

			}
		}
	}

	exports = {
		init: init
	};

	return exports;

}());
